import { useQuery } from '@tanstack/react-query'
import { fetchMenu } from '../api/client'
import type { RestaurantMenu } from '../api/types'

export function useRestaurantMenu(slug: string) {
  return useQuery<RestaurantMenu, Error>({
    queryKey: ['menu', slug],
    queryFn: () => fetchMenu(slug),
    staleTime: 60_000,
    retry: false,
  })
}
